/* eslint-disable */
import $ from 'jquery';
import matchHeight from 'jquery-match-height';
/* eslint-enable */

export default function () {
  /* Jquery match height */
  $('.footer-list').matchHeight();
}
